import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import OtherRenewableEnergyDetail from '../../components/renewable_energy/OtherRenewableEnergyDetail';
import { createOtherRenewableEnergy } from '../../redux/renewable_energy/other_renewable_energy_actions';

class OtherRenewableEnergyCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.solarEnergyDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newRenewableEnergy = this.solarEnergyDetail.getWrappedInstance().getRenewableEnergyData();
    this.props.createRenewableEnergy(newRenewableEnergy);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create other renewable energy')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OtherRenewableEnergyDetail
            ref={ref => (this.solarEnergyDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="renewable-energy-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const otherEnergyState = state.renewableEnergy.otherEnergy;
  return {
    errorMessage: otherEnergyState.errorMessage,
    isCreating: otherEnergyState.isCreating,
  };
};

const mapDispatchToProps = dispatch => ({
  createRenewableEnergy: solarEnergy =>
    dispatch(
      createOtherRenewableEnergy(
        solarEnergy.name,
        solarEnergy.energy,
        solarEnergy.description || '',
        solarEnergy.image,
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(OtherRenewableEnergyCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/renewable_energy/OtherRenewableEnergyCreateModal.js